export const messages = {
  en: {
    reportProficient: {
      search: {
        title: 'Search Conditions',
        roomPlaceholder: 'Please enter room number',
        carPlaceholder: 'Please enter license plate number'
      },
      export: 'Export',
      reset: 'Reset',
      roomFee: 'Room Fee Ledger',
      carFee: 'Car Fee Ledger'
    },
    reportProficientRoomFee: {
      name: 'Name',
      roomNumber: 'Room Number',
      phone: 'Phone',
      area: 'Area',
      feeType: 'Fee Type',
      feeName: 'Fee Name',
      year: ' Year',
      tip: 'Make sure the scheduled task is enabled when there is no data'
    },
    reportProficientCarFee: {
      name: 'Name',
      carNumber: 'License Plate',
      phone: 'Phone',
      feeType: 'Fee Type',
      feeName: 'Fee Name',
      year: ' Year',
      tip: ' '
    },
    viewFeeDetail: {
      yearFeeHistory: ' Year Payment History',
      cycle: 'Cycle(Month)',
      receivableAmount: 'Receivable Amount(Yuan)',
      receivedAmount: 'Received Amount(Yuan)',
      paymentTime: 'Payment Time',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      remark: 'Remark'
    }
  },
  zh: {
    reportProficient: {
      search: {
        title: '查询条件',
        roomPlaceholder: '请填写房屋编号',
        carPlaceholder: '请填写车牌号'
      },
      export: '导出',
      reset: '重置',
      roomFee: '房屋费台账',
      carFee: '车辆费台账'
    },
    reportProficientRoomFee: {
      name: '姓名',
      roomNumber: '房号',
      phone: '联系电话',
      area: '面积',
      feeType: '收费类型',
      feeName: '费用名称',
      year: '年',
      tip: '没有数据时，确保开启了定时任务'
    },
    reportProficientCarFee: {
      name: '姓名',
      carNumber: '车牌号',
      phone: '联系电话',
      feeType: '收费类型',
      feeName: '费用名称',
      year: '年',
      tip: ' '
    },
    viewFeeDetail: {
      yearFeeHistory: '年缴费历史',
      cycle: '周期(单位:月)',
      receivableAmount: '应收金额(单位:元)',
      receivedAmount: '实收金额(单位:元)',
      paymentTime: '缴费时间',
      startTime: '缴费起始时间',
      endTime: '缴费结束时间',
      status: '状态',
      remark: '备注'
    }
  }
}